import type { Asset } from '@/modules/Asset/interface/Asset';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetAssets = (params: GetAssetsParams) =>
  useQuery({
    queryKey: ['assets', params],
    queryFn: () => getAssets(params),
  });

const getAssets = async (params: GetAssetsParams) => {
  const { data } = await api.get<{ data: Asset[] }>(
    apiConfig.routes.assets.list,
    { params }
  );
  return data.data;
};

type GetAssetsParams = {
  search: string;
  page: number;
  limit: number;
};
